import { useState } from 'react';
import PresentationContainer from 'react-presentation-container';

import OrganizationService from '@/services/organization.service';

import Organizations from './Organizations.component';
import { useQuery } from 'react-query';

export default PresentationContainer({
  component: Organizations,
  controller: function AffiliatesController() {
    const { data, refetch } = useQuery('OrganizationService.read', () =>
      OrganizationService.read(),
    );
    const [selectedOrganization, setSelectedOrganization] = useState();
    const [errors, setErrors] = useState([]);

    const handleDeleteOrganizationPress = async (organization) => {
      await OrganizationService.update(organization.id, { active: false });
      refetch();
    };
    const handleUpdateOrganizationPress = async (organization) => {
      setSelectedOrganization(organization);
    };

    const handleCloseOrganizationModal = () => setSelectedOrganization(undefined);
    const handleCreateOrganizationPress = () => setSelectedOrganization({});
    const handleOrganizationSubmit = async ({ name, affiliate, user }) => {
      try {
        if (!selectedOrganization.id) {
          await OrganizationService.create({ name, affiliateId: affiliate.id, userId: user.id });
        } else {
          await OrganizationService.update(selectedOrganization.id, {
            name,
            affiliateId: affiliate.id,
            userId: user.id,
          });
        }

        setSelectedOrganization(undefined);
        refetch();
      } catch (e) {
        setErrors([e.message]);
      }
    };
    const handleErrorsClose = () => {
      setErrors([]);
    };

    return {
      organizations: data ?? [],
      selectedOrganization,
      errors,
      handleDeleteOrganizationPress,
      handleUpdateOrganizationPress,
      handleCloseOrganizationModal,
      handleCreateOrganizationPress,
      handleOrganizationSubmit,
      handleErrorsClose,
    };
  },
});
